/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Footer_Link_How_It_WorksInputs */

const en_directory_footer_link_how_it_works = /** @type {(inputs: Directory_Footer_Link_How_It_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How it works`)
};

const zh_directory_footer_link_how_it_works = /** @type {(inputs: Directory_Footer_Link_How_It_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`运作方式`)
};

/**
* | output |
* | --- |
* | "How it works" |
*
* @param {Directory_Footer_Link_How_It_WorksInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_footer_link_how_it_works = /** @type {((inputs?: Directory_Footer_Link_How_It_WorksInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Footer_Link_How_It_WorksInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_footer_link_how_it_works(inputs)
	return zh_directory_footer_link_how_it_works(inputs)
});
export { directory_footer_link_how_it_works as "directory.footer.link_how_it_works" }